import React, { useState } from "react";
import "./DocTable.css";

const DocTable: React.FC<any> = ({data}) => {
  const tableData = Array.isArray(data) ? data : [];
  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedSelectedItems;
    if (checked) {
      updatedSelectedItems = [...selectedFiles, value];
    } else {
      updatedSelectedItems = selectedFiles.filter((item) => item !== value);
    }
    setSelectedFiles(updatedSelectedItems); 
    console.log('Selected files:', updatedSelectedItems);
  };

  return (
    <>
    { data !==undefined ?
    <div className="scroll-table-container">
      
       <table className="styled-table">
        <thead>
          <tr>
            <th style={{ width: "40px" }}></th>
            <th>File</th>
            <th># keywords</th>
            <th>@ Owner </th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  value={item.file_name}
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>{item.file_name}</td>
              <td>{item.keywords.join(", ")}</td>
              <td>{item.owner}</td>
            </tr>
          ))}
        </tbody>
      </table> 
    
    </div>
: null}
    </>
  );
};

export default DocTable;
